(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["echo-hero-slider"] && !Shopify.designMode) return;
  try {
    
window.addEventListener('DOMContentLoaded', function() {
  const sliderContainer = document.querySelector('.hero-slides');
  const slides = sliderContainer.querySelectorAll('.hero-slide');
  let currentSlide = 0;
  let isAnimating = false;
  const autoplaySpeed = parseInt(sliderContainer.dataset.autoplay);
  let autoplayTimer = null;

  function showSlide(index, direction = 'next') {
    if (isAnimating || slides.length <= 1) return;
    isAnimating = true;

    // Normalize the index
    index = (index + slides.length) % slides.length;
    
    // Get current and next slides
    const currentEl = slides[currentSlide];
    const nextEl = slides[index];
    
    // Prepare next slide
    nextEl.style.zIndex = '1';
    
    // Show next slide
    requestAnimationFrame(() => {
      nextEl.classList.add('active');
      
      // Start transition out for current slide
      requestAnimationFrame(() => {
        currentEl.classList.remove('active');
        
        // Wait for transition to complete
        setTimeout(() => {
          currentSlide = index;
          isAnimating = false;
        }, 800); // Match this with CSS transition duration
      });
    });

    // Reset autoplay timer
    resetAutoplay();
  }

  function nextSlide() {
    showSlide(currentSlide + 1, 'next');
  }

  function prevSlide() {
    showSlide(currentSlide - 1, 'prev');
  }

  function resetAutoplay() {
    if (autoplayTimer) {
      clearInterval(autoplayTimer);
    }
    autoplayTimer = setInterval(nextSlide, autoplaySpeed);
  }

  // Initialize autoplay
  if (slides.length > 1) {
    resetAutoplay();

    // Add event listeners for hover
    sliderContainer.addEventListener('mouseenter', () => {
      clearInterval(autoplayTimer);
    });

    sliderContainer.addEventListener('mouseleave', resetAutoplay);
  }

  // Add navigation methods to window for section render updates
  window.heroSlider = {
    next: nextSlide,
    prev: prevSlide,
    goTo: showSlide,
    resetAutoplay
  };
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eco-header"]) return;
  try {
    
let lastScroll = 0;

function updateHeader() {
  const currentScroll = window.scrollY;
  const header = document.querySelector('header');
  
  if (currentScroll > 50) {
    header.classList.add('scrolled');
  } else {
    header.classList.remove('scrolled');
  }
  
  lastScroll = currentScroll;
}

// Initial check
updateHeader();

// Update on scroll
window.addEventListener('scroll', updateHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
